"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var uiComponents_exports = {};
__export(uiComponents_exports, {
  OrganizationProfile: () => OrganizationProfile,
  SignIn: () => SignIn,
  SignUp: () => SignUp,
  UserProfile: () => UserProfile
});
module.exports = __toCommonJS(uiComponents_exports);
var import_clerk_react = require("@clerk/clerk-react");
var import_internal = require("@clerk/clerk-react/internal");
var import_react = __toESM(require("react"));
var import_usePathnameWithoutSplatRouteParams = require("./usePathnameWithoutSplatRouteParams");
const UserProfile = Object.assign(
  (props) => {
    const path = (0, import_usePathnameWithoutSplatRouteParams.usePathnameWithoutSplatRouteParams)();
    return /* @__PURE__ */ import_react.default.createElement(import_clerk_react.UserProfile, { ...(0, import_internal.useRoutingProps)("UserProfile", props, { path }) });
  },
  { ...import_clerk_react.UserProfile }
);
const OrganizationProfile = Object.assign(
  (props) => {
    const path = (0, import_usePathnameWithoutSplatRouteParams.usePathnameWithoutSplatRouteParams)();
    return /* @__PURE__ */ import_react.default.createElement(import_clerk_react.OrganizationProfile, { ...(0, import_internal.useRoutingProps)("OrganizationProfile", props, { path }) });
  },
  { ...import_clerk_react.OrganizationProfile }
);
const SignIn = (props) => {
  const path = (0, import_usePathnameWithoutSplatRouteParams.usePathnameWithoutSplatRouteParams)();
  return /* @__PURE__ */ import_react.default.createElement(import_clerk_react.SignIn, { ...(0, import_internal.useRoutingProps)("SignIn", props, { path }) });
};
const SignUp = (props) => {
  const path = (0, import_usePathnameWithoutSplatRouteParams.usePathnameWithoutSplatRouteParams)();
  return /* @__PURE__ */ import_react.default.createElement(import_clerk_react.SignUp, { ...(0, import_internal.useRoutingProps)("SignUp", props, { path }) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  OrganizationProfile,
  SignIn,
  SignUp,
  UserProfile
});
//# sourceMappingURL=uiComponents.js.map